import {
    fetchMandatesTransactionListRequest,
    updateMandateStatusRequest,
    resetMandateTransactionList,
} from 'containers/Mandate/redux/mandates.actions';
import {
    DEFAULT_CURRENCY,
    MANDATE_TRANSACTION_STATUS_MAP,
} from 'utils/constants/commonValues';
import useInfiniteScroll from 'hooks/useInfiniteScroll';
import fcLoader from '../../static/images/generating.gif';
import NoResult from '../../static/images/noDataFound.png';

import CalendarImage from '../../static/images/calender.png';
import {
    MANDATE_BILLING_DETAILS_BASIC_MAP,
    MANDATE_BILLING_DETAILS_MAP,
    MANDATE_CUSTOMER_DETAILS_MAP,
} from './constant';

import MandateUpdateForm from './MandateUpdateForm';
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const MandateSidePanel = ({ data, mandateData, actions }) => {
    const { billingDetails } = data;
    const { mandateTransactionData } = mandateData;
    const {
        details,
        hasNextPage,
        isLoading,
        isUpdating,
    } = mandateTransactionData;

    const [pageNo, setPageNo] = useState(1);
    const pageSize = 4;

    const scrollTriggerController = (pageSize, newPageNumber) => {
        setPageNo(newPageNumber);
    };

    const scrollContainerRef = useInfiniteScroll({
        hasNextPage,
        delay: 500,
        pageSize,
        pageNumber: pageNo,
        loadMore: scrollTriggerController,
        scrollTriggerGap: 100,
    });

    // NOTE: sending mandateProductRefId as referenceId, as consumed by MMS service
    useEffect(() => {
        const payload = {
            referenceId: data.mandateProductRefId,
            pageNo,
            pageSize,
        };
        actions.fetchMandatesTransactionListRequest(payload);
    }, [actions, data.mandateProductRefId, pageNo]);

    return (
        <div>
            <div className="side-panel-data">
                <div className="section">
                    <div className="section-header">
                        <h3>Customer Details</h3>
                        <div className={`badge ${data.status}`}>
                            {data.status}
                        </div>
                    </div>
                    <div className="row">
                        {MANDATE_CUSTOMER_DETAILS_MAP.map((item, itemIndex) => {
                            return (
                                <div
                                    key={`customer-details-${itemIndex}`}
                                    className="column"
                                >
                                    <div className="label">{item.label}</div>
                                    <div className="user-text">
                                        {data[item.key] || '-'}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="section">
                    <h3>Billing Details</h3>
                    <div className="row">
                        {MANDATE_BILLING_DETAILS_MAP.map((item, itemIndex) => {
                            return (
                                <div
                                    key={`billing-details-${itemIndex}`}
                                    className="column"
                                >
                                    <div className="label">{item.label}</div>
                                    <div className="user-text">
                                        {billingDetails[item.key] || '-'}
                                    </div>
                                </div>
                            );
                        })}
                        {MANDATE_BILLING_DETAILS_BASIC_MAP.map(
                            (item, itemIndex) => {
                                return (
                                    <div
                                        key={`billing-details-basic-${itemIndex}`}
                                        className="column"
                                    >
                                        <div className="label">
                                            {item.label}
                                        </div>
                                        <div className="user-text">
                                            {data[item.key] || '-'}
                                        </div>
                                    </div>
                                );
                            }
                        )}
                    </div>
                </div>

                {data.remarks ? (
                    <div className="section">
                        <h3 className="heading">Last Comment</h3>
                        <p className={`user-text remark ${data.status}`}>
                            {data.remarks}
                        </p>
                    </div>
                ) : (
                    <></>
                )}

                {!['CANCELLED', 'COMPLETED', 'FAILED'].includes(data.status) ? (
                    <div className="section statusSection">
                        <MandateUpdateForm
                            data={data}
                            isUpdating={isUpdating}
                        />
                        {isUpdating ? (
                            <div className="updating">
                                <img
                                    src={fcLoader}
                                    alt="Loading"
                                    className="loading"
                                />
                                <div>
                                    Mandate Status is{' '}
                                    <span className="warn"> Updating...</span>
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                ) : (
                    <></>
                )}

                <div className="section">
                    <h3 className="heading">Transaction History</h3>
                    {!isLoading && details.length <= 0 ? (
                        <div className="no-result">
                            <img src={NoResult} alt="No Result" />
                            No Transaction History found.
                        </div>
                    ) : (
                        <></>
                    )}
                    <div
                        className="child-container"
                        ref={scrollContainerRef}
                        style={{ overflowY: 'auto', maxHeight: '400px' }}
                    >
                        {details.map((txnDetail, txnDetailIndex) => {
                            return (
                                <div
                                    className="transaction-detail-container"
                                    key={`transaction-detail-${txnDetailIndex}`}
                                >
                                    <div className="calender-view">
                                        <img
                                            src={CalendarImage}
                                            alt="calenderImage"
                                        />
                                        <p className="date">
                                            {
                                                txnDetail.executionDate.split(
                                                    ','
                                                )[0]
                                            }
                                        </p>
                                        <p className="time">
                                            {
                                                txnDetail.executionDate.split(
                                                    ','
                                                )[1]
                                            }
                                        </p>
                                    </div>
                                    <div className="transaction-detail-view">
                                        <div className="text-details">
                                            <div className="detail">
                                                <div className="label">
                                                    Order ID
                                                </div>
                                                <div className="value">
                                                    {txnDetail.orderId || '-'}
                                                </div>
                                            </div>
                                            <div className="detail">
                                                <div className="label">
                                                    Transaction ID
                                                </div>
                                                <div className="value">
                                                    {txnDetail.transactionId ||
                                                        '-'}
                                                </div>
                                            </div>
                                            <div className="detail">
                                                <div className="label">
                                                    Remarks
                                                </div>
                                                <div className="value">
                                                    {txnDetail.remarks || '-'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="amount-details">
                                            <div
                                                className={`status ${txnDetail.status}`}
                                            >
                                                {
                                                    MANDATE_TRANSACTION_STATUS_MAP[
                                                        txnDetail.status
                                                    ]
                                                }
                                            </div>
                                            <div className="amount">
                                                {DEFAULT_CURRENCY}{' '}
                                                {txnDetail.amount
                                                    ? txnDetail.amount
                                                    : 'N/A'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        {isLoading && hasNextPage ? (
                            <img
                                src={fcLoader}
                                alt="Loading"
                                className="loading"
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

MandateSidePanel.propTypes = {
    data: PropTypes.object,
    mandateData: PropTypes.object,
    actions: PropTypes.object,
};

const mapStateToProps = ({ auth, mandateData, loader }) => ({
    auth,
    mandateData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchMandatesTransactionListRequest,
            updateMandateStatusRequest,
            resetMandateTransactionList,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MandateSidePanel);
